import { ProjectAssigneePicker } from 'components/molecules/assignee-picker';
import { TaskAssigneePicker } from 'components/molecules/squad-picker/assignee-picker';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacTaskAssigneePicker = withAccess(TaskAssigneePicker);
export const RbacProjectAssigneePicker = withAccess(ProjectAssigneePicker);
